import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to: Route, from: Route, savedPosition: any) {
    if (savedPosition) {
      return savedPosition;
    }

    return {
      x: 0,
      y: 0,
      behavior: 'smooth',
    };
  },
});

export default router;
